import { render } from "./Terminal.vue?vue&type=template&id=bc35795e&scoped=true"
import script from "./Terminal.vue?vue&type=script&lang=js"
export * from "./Terminal.vue?vue&type=script&lang=js"

import "./Terminal.vue?vue&type=style&index=0&id=bc35795e&scoped=true&lang=css"

import exportComponent from "/home/builder/shared-storage/.project-directory/builder-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc35795e"]])

export default __exports__